import { render, staticRenderFns } from "./effectB.vue?vue&type=template&id=c00116dc&scoped=true"
import script from "./effectB.vue?vue&type=script&lang=js"
export * from "./effectB.vue?vue&type=script&lang=js"
import style0 from "./effectB.vue?vue&type=style&index=0&id=c00116dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00116dc",
  null
  
)

export default component.exports